if (window.location.pathname === '/') {
    navigator.geolocation.getCurrentPosition(
        (position) => {
            localStorage.setItem(
                'location',
                JSON.stringify({
                    timestamp: position.timestamp,
                    coords: {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    },
                })
            );
        },
        () => {
            localStorage.setItem('location', '-1');
        }
    );
}
